module.exports = __webpack_public_path__ + "static/media/停用.6fcdcc5f.svg";